import { FIlterTypeVehicles } from '../store/vehicles/types'
import axiosInstance from './axios'
import { AxiosResponse } from 'axios'

class VehiclesService {

    constructor(private apiVersion: string = 'v1') {
    }

    public async getVehicles(filter: string, filterType: FIlterTypeVehicles): Promise<any> {
        try {
            const url: string = `${this.apiVersion}/vehicles`
            if (filterType === FIlterTypeVehicles.PLATE) {
                return axiosInstance.get(`${url}?plate=${filter}`)
                    .then((response: AxiosResponse) => response.data)
            }
            if (filterType === FIlterTypeVehicles.RENAVAM) {
                return axiosInstance.get(`${url}?renavam=${filter}`)
                    .then((response: AxiosResponse) => response.data)
            }
            if (filterType === FIlterTypeVehicles.CHASSI) {
                return axiosInstance.get(`${url}?chassi=${filter}`)
                    .then((response: AxiosResponse) => response.data)
            }
        } catch (err: any) {
            throw new Error(err.message)
        }
    }
}

const vehicleService = new VehiclesService()

export default vehicleService
